import SsciStudentApplications from "./SsciStudentApplications";

export default SsciStudentApplications;